import ImageSlider from '../ImageSlider';
import VillaSlider from '../VillaSlider';
import Footer from '../Contact';
import Spotlight from '../Spotlight';
import Luxeunbounded from '../Luxeunbounded';
import ScrollReveal from '../ScrollReveal'; 

function VillaList() {
  return (
    <>
    <ScrollReveal><ImageSlider/></ScrollReveal>
    <ScrollReveal><VillaSlider/></ScrollReveal>
    <ScrollReveal><Spotlight/></ScrollReveal>
    <ScrollReveal><Luxeunbounded/></ScrollReveal>
    <ScrollReveal><Footer/></ScrollReveal>
    </>
  );
}

export default VillaList;